import { render, staticRenderFns } from "./priceReview.vue?vue&type=template&id=4494e471"
import script from "./priceReview.vue?vue&type=script&lang=js"
export * from "./priceReview.vue?vue&type=script&lang=js"
import style0 from "./priceReview.vue?vue&type=style&index=0&id=4494e471&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports